export default __webpack_public_path__ + "static/media/partners-banner.497d7cf4.png";